export default "__VITE_ASSET__C_MQKPqD__"